// スクロール時に追従メニュー表示切り替え
$(window).scroll(function () {
  var header = $('.l-header');
  var sub = $('.l-subheader');
  var width = window.innerWidth;

  // SP版でスクロール時に画面下部固定メニューの表示切り替えをする
  if (width < 768) {
    // 画面下部固定メニューがアクティブ時には切り替えない
    if ($('.fixedMenu').hasClass('is-active')) {
      return false;
    }
    if ($(window).scrollTop() > 250) {
      $('.fixedMenu').css('bottom', 0);
    } else {
      $('.fixedMenu').css('bottom', '-68px');
    }
  }

  // SP以外でスクロール時に追従メニューの表示切り替えをする
  if (width >= 768) {
    if ($(window).scrollTop() > 500) {
      if (!header.hasClass('onscroll')) {
        $.when(header.hide(), sub.hide()).done(function () {
          header.fadeIn(200).addClass('onscroll');
        });
      }
    } else {
      if (header.hasClass('onscroll')) {
        $.when(header.hide(), sub.hide()).done(function () {
          header.fadeIn(200).removeClass('onscroll');
        });
      }
    }
  }
});

// メガメニュー表示切り替え
$('.js-toggleNav').on('click', function () {
  $('.js-toggleNav').each(function () {
    $(this).toggleClass('is-active');
  });
  $('nav.l-nav').toggleClass('is-active').fadeToggle(200);

  // サブヘッダーを閉じる
  $('.l-subheader.-restaurant').hide();
  $('.l-subheader.-stay').hide();

  // SPでは画面下部固定メニューを表示させ、予約フォームを閉じる
  // また、メガメニュー表示時はヘッダをつねに表示する
  var width = window.innerWidth;
  if (width < 768) {
    $('.l-header').toggleClass('fixed');
    $('.fixedMenu').css('bottom', 0);
    $('.btn-reserve').removeClass('is-active');
    $('.fixedMenu').removeClass('is-active');
    $('.fixedMenu-reservation').fadeOut(200);
  }
});

// SP版メガメニューアコーディオン表示切り替え
$('.js-toggleSubMenu').on('click', function () {
  $(this).toggleClass('is-open');
  $(this).siblings('.sub-block').slideToggle();
});

// スムーススクロール
$('a[href^="#"]').click(function () {
  var href = $(this).attr("href");
  var target = $(href == "#" || href == "" ? 'html' : href);

  // よくある質問ページのサブカテゴリではスクロール位置を調整
  if (href.indexOf('#subSec') > -1) {
    var pos = target.offset().top - 40;
  } else {
    var pos = target.offset().top;
  }
  $('body, html').animate({
    scrollTop: pos
  }, 400);
  return false;
});